import * as qs from 'query-string'

export default class Route {
  public static get MobileDataUsage(): string {
    return '/mobility'
  }

  public static get viewPlans(): string {
    return 'plans'
  }

  public static get OfferDetailsStrategic(): string {
    return 'offerDetails/:planType/:planTypeCode/:offerId/:billingNumber/:cidn'
  }

  public static get OfferDetailsLegacy(): string {
    return 'offerDetails/:planType/:planTypeCode/:offerId/:billingNumber'
  }

  public static ViewOfferDetails(
    offerId: string,
    billingNumber: string,
    planType: string,
    planTypeCode: string,
    cidn: string = '',
  ): string {
    return cidn
      ? this.OfferDetailsStrategic.replace(':offerId', encodeURIComponent(offerId))
          .replace(':planType', encodeURIComponent(planType))
          .replace(':planTypeCode', encodeURIComponent(planTypeCode))
          .replace(':billingNumber', encodeURIComponent(billingNumber))
          .replace(':cidn', encodeURIComponent(cidn))
      : this.OfferDetailsLegacy.replace(':offerId', encodeURIComponent(offerId))
          .replace(':planType', encodeURIComponent(planType))
          .replace(':planTypeCode', encodeURIComponent(planTypeCode))
          .replace(':billingNumber', encodeURIComponent(billingNumber))
  }

  public static get StrategicServiceDetails(): string {
    return 'serviceDetails/:planType/:offerId/:billingNumber/:serviceSubscriptionId/:serviceId/:cidn'
  }

  public static get StrategicServiceDetailsWithoutCidn(): string {
    return 'serviceDetails/:planType/:offerId/:billingNumber/:serviceSubscriptionId/:serviceId'
  }

  public static ViewStrategicServiceDetails(
    offerId: string,
    billingNumber: string,
    serviceId: string,
    planType: string,
    serviceSubscriptionId: string,
    cidn: string = '',
    object = {queryStringObj: null},
  ): string {
    const basePath = cidn
      ? this.StrategicServiceDetails.replace(':planType', encodeURIComponent(planType))
          .replace(':offerId', encodeURIComponent(offerId))
          .replace(':billingNumber', encodeURIComponent(billingNumber))
          .replace(':serviceSubscriptionId', encodeURIComponent(serviceSubscriptionId))
          .replace(':serviceId', encodeURIComponent(serviceId))
          .replace(':cidn', encodeURIComponent(cidn))
      : this.StrategicServiceDetailsWithoutCidn.replace(':planType', encodeURIComponent(planType))
          .replace(':offerId', encodeURIComponent(offerId))
          .replace(':billingNumber', encodeURIComponent(billingNumber))
          .replace(':serviceSubscriptionId', encodeURIComponent(serviceSubscriptionId))
          .replace(':serviceId', encodeURIComponent(serviceId))

    const {queryStringObj} = object
    if (queryStringObj) {
      const pathWithQueryString = qs.stringify(queryStringObj, {
        arrayFormat: 'separator',
        arrayFormatSeparator: '|',
        skipNull: true,
        skipEmptyString: true,
      })
      return `${basePath}?${pathWithQueryString}`
    }

    return basePath
  }

  public static get LegacyServiceDetails(): string {
    return 'serviceDetails/:planType/:offerId/:billingNumber/:serviceId'
  }

  public static ViewLegacyServiceDetails(
    offerId: string,
    billingNumber: string,
    serviceId: string,
    planType: string,
  ): string {
    return this.LegacyServiceDetails.replace(':planType', encodeURIComponent(planType))
      .replace(':offerId', encodeURIComponent(offerId))
      .replace(':billingNumber', encodeURIComponent(billingNumber))
      .replace(':serviceId', encodeURIComponent(serviceId))
  }
  public static get trackServiceDetails(): string {
    return '/app/service-requests/view/requests/:serviceNumber/summary'
  }
  public static trackServiceRequestDetails(serviceNumber: string): string {
    return this.trackServiceDetails.replace(':serviceNumber', encodeURIComponent(serviceNumber))
  }
  public static get SubmitABugURL(): string {
    return '/app/support/error-report'
  }

  public static get GetSupportURL(): string {
    return '/app/customer-support/new-enquiry'
  }

  public static get viewMobileServices(): string {
    return 'mobile-services'
  }
  public static unifiedTrackingPath(): string {
    return '/tracking/requests'
  }
  public static ypsServiceCatalogueMobility(): string {
    return '/service-requests/your-products-and-services/mobility-solutions/request-catalogue'
  }
  public static imsCreateincidents(): string {
    return '/incidents/new-incident'
  }
  public static imsTrackincidents(): string {
    return '/tracking/incidents?source=card&action=status'
  }
  public static orderExpressShop(): string {
    return '/connect-store/mobility'
  }
  public static requestFAQs(): string {
    return '/support/faq#Mobility'
  }
  public static supportCreateEnquiry(): string {
    return '/customer-support/new-enquiry'
  }
  public static supportTrackEnquiry(): string {
    return '/tracking/enquiries'
  }
  public static get NotFound(): string {
    return 'not-found'
  }
  public static get NotAuthorised(): string {
    return 'not-authorised'
  }
  public static get billingTileRoute() {
    return `/app/billing/summary/invoices?billingAccount=:accountNumber`
  }
  public static setBillingTileRoute(accountNumber: string) {
    return this.billingTileRoute.replace(':accountNumber', accountNumber)
  }

  public static get mobileServicesDetailStrategic(): string {
    return 'mobile-services/strategic/:serviceNumber/detail'
  }

  public static get mobileServicesDetailLegacy(): string {
    return 'mobile-services/:userStack/:serviceNumber/detail'
  }
  public static get MpexDynamic5g(): string {
    return `dynamic-5g/:view`
  }
  public static get MpexDynamic5gStrategicDetails(): string {
    return `mobile-services/:serviceNumber/dynamic-5g/:view`
  }
  public static getMpexDynamicCustomerRoute(view: string, serviceNumber?: string): string {
    return serviceNumber
      ? this.MpexDynamic5gStrategicDetails.replace(':view', encodeURIComponent(view)).replace(
          ':serviceNumber',
          encodeURIComponent(serviceNumber),
        )
      : this.MpexDynamic5g.replace(':view', encodeURIComponent(view))
  }

  public static ViewMobileServicesDetailStrategic(
    serviceNumber: string,
    userStack: string,
  ): string {
    return userStack === 'legacy'
      ? this.mobileServicesDetailLegacy
          .replace(':userStack', encodeURIComponent(userStack))
          .replace(':serviceNumber', encodeURIComponent(serviceNumber))
      : this.mobileServicesDetailStrategic
          .replace(':userStack', encodeURIComponent(userStack))
          .replace(':serviceNumber', encodeURIComponent(serviceNumber))
  }
  public static get maximFormURL(): string {
    return 'maxim-form'
  }
  public static get maximFormFromMobileServicesPage(): string {
    return `/app/service-requests/${this.viewMobileServices}/${this.maximFormURL}`
  }

  public static get MobileDataUsageMeter(): string {
    return '/app/mobile-data-usage-meter/*'
  }
  public static get Dashboard(): string {
    return '/app/dashboard'
  }
  public static get YourProductsAndServices(): string {
    return '/app/service-requests/your-products-and-services'
  }
  public static get Mobility(): string {
    return '/app/mobility/mobile-services'
  }
  public static OfferDetails(offerId, billingNumber, planType, planTypeCode, cidn): string {
    return (
      '/app/mobility/' + this.ViewOfferDetails(offerId, billingNumber, planType, planTypeCode, cidn)
    )
  }
  public static get Invoices(): string {
    return '/app/billing/summary/invoices'
  }

  public static get MobileServices(): string {
    return '/app/mobile-data-usage-meter/mobile-services'
  }

  public static ServiceRequestManage(): string {
    return '/service-requests/manage'
  }
}
